import React from 'react';
import './ThematicItem.less';

interface ThematicItemPropType {
    prefixCls?: string;
    data?: any;
    onItemClick?: (id?: any) => void;
}

/**
 * 专题列表Item
 * @class ThematicItem
 * @extends {React.Component<ThematicItemPropType, any>}
 */
class ThematicItem extends React.Component<ThematicItemPropType, any> {
    static defaultProps = {
        prefixCls: 'thematic-item'
    };

    render() {
        const {prefixCls, data = {}, onItemClick} = this.props;
        return (
            <div className={`${prefixCls}`} onClick={onItemClick}>
                <div className={`${prefixCls}-img-box`}>
                    <img src={data.specialImg} alt=""/>
                    {
                        data.isStarting && (
                            <div className={`${prefixCls}-float`}>
                                <span>已结束</span>
                            </div>
                        )
                    }
                </div>
                <div className={`${prefixCls}-title-box`}>
                    <span className={`${prefixCls}-border` + (data.isStarting ? ` ${prefixCls}-border-end` : ``)}/>
                    <p className={data.isStarting ? `${prefixCls}-p-end` : ``}>{data.specialName}</p>
                </div>
            </div>
        );
    }
}

export default ThematicItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/specialItem/thematicItem/ThematicItem.tsx